import theme from './theme';

const isMobile = () => (typeof window !== 'undefined' && window.innerHeight < 768 && window.innerWidth < theme.breakpoints[1]);

export default isMobile;
